export default __webpack_public_path__ + "static/media/The Silent Knell.5fc5169c.jpg";